import { Box, Button, TextField } from "@mui/material";
import React from "react";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";

const setGearSizePattern = function (validationData) {
  if (
    validationData &&
    validationData.hasOwnProperty("SIZE_MINIMUM") &&
    validationData.hasOwnProperty("SIZE_MAXIMUM")
  ) {
    return validationData.SIZE_MINIMUM + " - " + validationData.SIZE_MAXIMUM;
  }
  return "no valid pattern";
};

const styles = {
  numberInput: {
    textAlign: "center",
    alignSelf: "leftmm",
  },
};

export default function GearSize(props) {
  // Created unique array to avoid duplicate buttons with same value
  const uniqueGearPreference = [
    ...props.gear_preference
      .reduce(
        (gear_preference, obj) => gear_preference.set(obj.gearsize, obj),
        new Map()
      )
      .values(),
  ];
  return (
    <Box mt={0} width="100%" align="center" key={"gear_size_box"}>
      <h2 className="sectionTitle center">Gear Size</h2>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        key={"gear_size_grid"}
      >
        <Grid item xs={12} md="auto" key={"gear_size_grid_item"}>
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            key={"gear_size_pref_box"}
          >
            {uniqueGearPreference.map(
              (gear_code, idx) =>
                props.gearcode === gear_code.gearcode && (
                  <Box m={0.5} key={"gear_size_box_" + idx}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className="form-input"
                      data-new-value={gear_code.gearsize}
                      data-field={"gearsize"}
                      size="large"
                      onClick={(e) =>
                        props.handleGearPreferenceChange(e, gear_code.gearsize)
                      }
                      id={gear_code.gearcode + gear_code.gearsize}
                      key={gear_code.gearcode + gear_code.gearsize}
                    >
                      {gear_code.gearsize}
                    </Button>
                  </Box>
                )
            )}
          </Box>
        </Grid>

        <Grid item xs={12} md="auto" key={"gear_size_field_grid"}>
          <FormControl>
            <TextField
              variant="standard"
              label="Gear Size:"
              className="number-of-input"
              inputProps={{ min: 0, style: styles.numberInput }}
              value={props.gearsize ? Number(props.gearsize) : ""}
              name="gearsize"
              type="number"
              onChange={(e) => props.handleInputChange(e)}
              helperText={setGearSizePattern(props.validation)}
              key={"gear_size_field"}
            />
          </FormControl>
          <HelpText helpText={getHelpText(props.helpText, "gear_size")} />
        </Grid>
      </Grid>
    </Box>
  );
}
